import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";


const MemberVerificationPopup = ({ memberCode ,onVerificationChange }) => {
   const navigate = useNavigate();
   const baseUrl = process.env.REACT_APP_API;

  const [verificationStatus, setVerificationStatus] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
    const checkVerificationStatus = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/member-verification/${memberCode}`
        );
        setVerificationStatus(response.data);
        
        // Notify parent component of verification status
        onVerificationChange(response.data);
        
        // if (response.data.IsEmailVerified !== 1 || !response.data.PhantomSolanaAddress) {
        //   setShowPopup(true);
        // }
      } catch (error) {
        console.error("Error fetching verification status:", error);
      }
    };

    if (memberCode) {
      checkVerificationStatus();
    }
  }, []);
  

  useEffect(() => {
    const checkVerificationStatus = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/member-verification/${memberCode}`
        );
        setVerificationStatus(response.data);
        
        // Show popup if either field is missing or invalid
        if (response.data.IsEmailVerified !== 1 || !response.data.PhantomSolanaAddress) {
          setShowPopup(true);
        }
      } catch (error) {
        console.error("Error fetching verification status:", error);
        toast.error('Failed to check verification status');
      }
    };

    if (memberCode) {
      checkVerificationStatus();
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '2rem',
        borderRadius: '12px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
        position: 'relative',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <button 
          onClick={closePopup}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontSize: '1.2rem',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
        
        <h2 style={{
          color: '#fff',
          marginBottom: '1.5rem',
          textAlign: 'center',
          fontSize: '1.5rem'
        }}>
          Complete Your Verification
        </h2>
        
        <div style={{ marginBottom: '1.5rem' }}>
          {(!verificationStatus || verificationStatus.IsEmailVerified !== 1) && (
            <div style={{
              background: 'rgba(255, 87, 34, 0.1)',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1rem',
              borderLeft: '4px solid #ff5722'
            }}>
              <h3 style={{ color: '#ff5722', marginBottom: '0.5rem' }}>
                Email Verification Required
              </h3>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Please verify your email address to buy tokens.
              </p>
              <button
                style={{
                  background: '#ff5722',
                  color: 'white',
                  border: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  marginTop: '0.5rem',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  navigate('/token/verify-email')
                }}
              >
                Verify Email
              </button>
            </div>
          )}
          
          {(!verificationStatus || !verificationStatus.PhantomSolanaAddress) && (
            <div style={{
              background: 'rgba(76, 175, 80, 0.1)',
              padding: '1rem',
              borderRadius: '8px',
              borderLeft: '4px solid #4caf50'
            }}>
              <h3 style={{ color: '#4caf50', marginBottom: '0.5rem' }}>
                Wallet Connection Required
              </h3>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Please connect your wallet to continue.
              </p>
              <button
                style={{
                  background: '#4caf50',
                  color: 'white',
                  border: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  marginTop: '0.5rem',
                  cursor: 'pointer'
                }}
                onClick={() => {
                navigate('/token/connect-wallet')
                }}
              >
                Connect Wallet
              </button>
            </div>
          )}
        </div>
        
        <p style={{
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '0.8rem',
          textAlign: 'center'
        }}>
          You need to complete these steps to buy tokens.
        </p>
      </div>
    </div>
  );
};

export default MemberVerificationPopup;